import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { AuthAction } from '../../store/actions';

class ForgotPassword extends PureComponent {
  static propTypes = {
    forgotPassword: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = { email: '' };
  }

  onChange(event) {
    const { target: { name, value } = {} } = event;
    this.setState({ [name]: value });
  }

  onSubmit(event) {
    event.preventDefault();
    this.props.forgotPassword(this.state);
  }

  render() {
    return (
      <div className="hold-transition login-page">
        <div className="login-box">
          <div className="card card-outline card-primary">
            <div className="card-header text-center">
              <b className="h1">Forgot Password</b>
            </div>
            <div className="card-body">
              <form onSubmit={this.onSubmit.bind(this)}>
                <div className="input-group mb-3">
                  <input
                    className="form-control"
                    name="email"
                    onChange={this.onChange.bind(this)}
                    placeholder="Email"
                    type="email"
                  />
                  <div className="input-group-append">
                    <div className="input-group-text">
                      <span className="fas fa-envelope"></span>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-6">
                    <button className="btn btn-block btn-primary" type="submit">
                      Send
                    </button>
                  </div>
                  <div className="col-6 text-right">
                    <Link to="/login">Sign In!</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  forgotPassword: data => dispatch(AuthAction.forgotPassword(data)),
});

export default connect(null, mapDispatchToProps)(ForgotPassword);
